<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :class="[`${prefix}-icon`, `${prefix}-icon-article`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_39db34b595__a"><rect x="2" y="2" width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#svg_39db34b595__a)"><path d="M4.275,2C3.575,2,3,2.575,3,3.275L3,16.725C3,17.425,3.575,18,4.275,18L15.725,18C16.425,18,17,17.425,17,16.725L17,7.075L12.275,2L4.275,2Z" :fill="useCurrentColor ? 'currentColor' : '#4776F8'"/><path d="M5.52490234375,11.349609375L10.92490234375,11.349609375L10.92490234375,11.874609375L5.52490234375,11.874609375L5.52490234375,11.349609375ZM5.52490234375,12.549609375L10.92490234375,12.549609375L10.92490234375,13.074609375L5.52490234375,13.074609375L5.52490234375,12.549609375ZM5.52490234375,13.749609375L10.92490234375,13.749609375L10.92490234375,14.274609375L5.52490234375,14.274609375L5.52490234375,13.749609375ZM5.52490234375,14.949609375L8.59990234375,14.949609375L8.59990234375,15.474609375L5.52490234375,15.474609375L5.52490234375,14.949609375Z" :fill="useCurrentColor ? 'currentColor' : '#FFF'"/><path d="M12.27490234375,2L12.27490234375,5.65C12.27490234375,6.05,12.54990234375,7.1,13.79990234375,7.1L16.99990234375,7.1L12.27490234375,2Z" :fill="useCurrentColor ? 'currentColor' : '#FFF'" opacity=".5"/></g></svg>
</template>
<script>

export default {
  name: 'IconArticle',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
